import { type ICellEditorParams } from "ag-grid-community";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";

import { isBackspace, isPrintableKey } from "@/ui-modules/core/grid/cells/editors/utils.ts";

import { TableCell } from "../core/TableCell.js";

export const StringCellEditor = forwardRef((props: ICellEditorParams, ref) => {
  const isPrintableEditingKey = isPrintableKey(props.eventKey);
  const isBackspaceKey = isBackspace(props.eventKey);
  const [value, setValue] = useState<string>(isPrintableEditingKey ? props.eventKey : props.value);
  const refInput = useRef(null);

  useEffect(() => {
    // focus on the input (doing this in afterGuiAttached does not seem to work)
    setTimeout(() => refInput.current.focus());
  }, []);

  const c = useCallback(() => {
    return {
      // the final value to send to the grid, on completion of editing
      getValue(): string {
        return value?.trim().length ? value.trim() : null;
      },
      afterGuiAttached: () => {
        refInput.current.focus();
      },
    };
  }, [value]);

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, c);

  return (
    <TableCell editor>
      <input
        className={"form-control"}
        ref={refInput}
        value={value}
        type="text"
        onChange={(event: any) => setValue(event.currentTarget.value)}
        onFocus={(event) => (isBackspaceKey ? setValue("") : isPrintableEditingKey ? undefined : event.target.select())}
        onBlur={() => props.stopEditing()}
      />
    </TableCell>
  );
});
